export default function loadAMap() {
    return new Promise((resolve, reject) => {
        if (window.AMap) return resolve(window.AMap); // 避免重复加载

        const script = document.createElement('script');
        script.src = `https://webapi.amap.com/maps?v=1.4.15&key=6db883e5d8779c91877983dc4a0b4cb8&plugin=AMap.ControlBar,AMap.MouseTool`;
        script.async = true;
        script.onload = () => resolve(window.AMap); // 加载成功返回AMap对象
        script.onerror = reject;
        document.head.appendChild(script);
    });
}